import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { BlogListStack } from "../../../components/BlogListStack";
import Gallery from "../../../components/Gallery";

import "./index.css"

const Draft = ({ content }) => {
    const data = useStaticQuery(
        graphql`
          query {
            allContentfulBlogPosts(
              sort: { fields: createdAt, order: DESC }
              filter: { isDraft: { eq: true } }
            ) {
              nodes {
                createdAt
                isDraft
                isHeaderDark
                publishDate
                title
                excerptContentOptions
                excerpt {
                  raw
                }
                intro{
                    intro
                }
                blogBodyContent {
                    textContent {
                      textContent
                    }
                }
                thumbnailImage {
                  gatsbyImageData(width: 2400, quality: 100)
                }
                blogPostUrlSlug
                categories {
                  title
                }
                parentCategory {
                  categoryName
                  slugId
                }
              }
            }
          }
        `
    )
    
    return (
      <>
        <BlogListStack 
            data={data.allContentfulBlogPosts.nodes} 
            blogTitle={'Drafts'}
            hasCatFilter={false}
        />
        {content.pageGallery !== null && (
          <>
            {content.pageGallery.map((galleryData, index) => (
                <Gallery key={index} galleryData={galleryData} />
            ))}
          </>
        )}
      </>
    )
}

export default Draft